import Constants from '../actions/types';

const initialState = {
  events: [],
  loading: false,
  message: null,
  severity: null,
  types: []
};

const auditEventsReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.AUDIT_EVENTS_GET_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };

      return newState;
    }

    case Constants.AUDIT_EVENTS_GET_SUCCESS: {
      const newState =
        action.payload.length === 0
          ? {
              ...state,
              loading: false,
              events: [],
              message:
                'No events were found that match the criteria specified.',
              severity: 'info'
            }
          : {
              ...state,
              loading: false,
              events: action.payload
            };

      return newState;
    }

    case Constants.AUDIT_EVENTS_GET_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.AUDIT_EVENTTYPES_GET_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };

      return newState;
    }

    case Constants.AUDIT_EVENTTYPES_GET_SUCCESS: {
      const newState = {
        ...state,
        loading: false,
        types: action.payload
      };

      return newState;
    }

    case Constants.AUDIT_EVENTTYPES_GET_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.AUDIT_EVENTS_CLEAR_ERROR: {
      const newState = {
        ...state,
        events: [],
        message: null,
        severity: null
      };

      return newState;
    }

    default: {
      return state;
    }
  }
};

export default auditEventsReducer;
